export const TRY_DIFFERENT_WORDS_TITLE = 'Try different search words';
export const TRY_DIFFERENT_WORDS_TIP = `For example, you'll get different
results when you search for light bulb and LED.`;
export const CHECK_SPELLING_TITLE = 'Check your spelling';
export const CHECK_SPELLING_TIP = 'Catching the smallest typo can make the biggest difference!';
export const EXACT_PHRASE_TITLE = 'Use exact phrase';
export const EXACT_PHRASE_MOBILE = '(i.e. model # or brand name)';
export const EXACT_PHRASE_TIP = 'You can even enter an item number, model number or brand name.';
export const GET_HELP = 'We Can Help';
export const ONLINE_ORDER_SUPPORT = `Call 1-800-430-3376 or
text 38698 for customer service`;
export const LOCAL_STORE = 'your Local Store';
export const CONTACT = 'Contact';
export const REFINE_SEARCH = 'Refine Your Search';
export const SEARCH_ALL_PRODUCTS = 'Search All Products';
export const SHOP_CUSTOM_PRODUCTS = 'Shop Custom Catalog Products';
